import React from "react";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "@mui/material/Button";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Config from "conFig.js";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const Capnhatkhoahoc = React.memo(function Capnhatkhoahoc(props) {
  const { cosodaotao_id, khoahocid } = props;
  const [hangxe, setHangxe] = React.useState("");
  const [khoa, setKhoa] = React.useState("");
  const [thoigiandaotao, setThoigiandaotao] = React.useState(0);
  const [ngaykhaigiang, setNgaykhaigiang] = React.useState(dayjs());
  const [ngaybegiang, setNgaybegiang] = React.useState(dayjs());
  const [soluonghocvien, setSoluonghocvien] = React.useState(0);
  const [soluonggiaovienlythuyet, setSoluonggiaovienlythuyet] = React.useState(
    0
  );
  const [soluonggiaovienthuchanh, setSoluonggiaovienthuchanh] = React.useState(
    0
  );
  const [soluongxe, setSoluongxe] = React.useState(0);
  const [ghichu, setGhichu] = React.useState("");
  const [alert, setAlert] = React.useState(false);
  const [messageValidate, setMessageValidate] = React.useState("");
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getthongtin = () => {
    var url =
      Config.backend +
      "/api/KhoaHoc/getkhoahocid?khoahoc_id=" +
      khoahocid +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHangxe(data[0].hang);
        setKhoa(data[0].khoa);
        setThoigiandaotao(data[0].thoigiandaotao);
        if (data[0].ngaykhaigiang) {
          setNgaykhaigiang(dayjs(data[0].ngaykhaigiang));
        }
        if (data[0].ngaybegiang) {
          setNgaybegiang(dayjs(data[0].ngaybegiang));
        }
        setSoluonghocvien(data[0].soluonghocvien);
        setSoluonggiaovienlythuyet(data[0].soluonggiaovienlythuyet);
        setSoluonggiaovienthuchanh(data[0].soluonggiaovienthuchanh);
        setSoluongxe(data[0].soluongxe);
        setGhichu(data[0].ghichu);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const capnhat = () => {
    var ngaykg =
      ngaykhaigiang.$y +
      "-" +
      String(ngaykhaigiang.$M + 1).padStart(2, "0") +
      "-" +
      ngaykhaigiang.$D;
    var ngaybg =
      ngaybegiang.$y +
      "-" +
      String(ngaybegiang.$M + 1).padStart(2, "0") +
      "-" +
      ngaybegiang.$D;
    var url = Config.backend + "/api/KhoaHoc/capnhatkhoahoc";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        khoahoc_id: khoahocid,
        hang: hangxe,
        khoa: khoa,
        thoigiandaotao: thoigiandaotao,
        ngaykhaigiang: ngaykg,
        ngaybegiang: ngaybg,
        ngaydangkysathach: null,
        soluonghocvien: soluonghocvien,
        soluonggiaovienlythuyet: soluonggiaovienlythuyet,
        soluonggiaovienthuchanh: soluonggiaovienthuchanh,
        soluongxe: soluongxe,
        ghichu: ghichu,
        cosodaotao_id: cosodaotao_id.id,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setMessageValidate(data);
          showNotification();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    getthongtin();
  }, []);
  return (
    <div>
      <CardBody style={{ borderBottom: "1px solid #bbb" }}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Hạng đào tạo"
                variant="outlined"
                size="small"
                value={hangxe}
                onChange={(event) => {
                  setHangxe(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Khóa"
                variant="outlined"
                size="small"
                value={khoa}
                onChange={(event) => {
                  setKhoa(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Thời gian đào tạo (ngày)"
                variant="outlined"
                size="small"
                type="number"
                value={thoigiandaotao}
                onChange={(event) => {
                  setThoigiandaotao(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày khai giảng"
                  value={ngaykhaigiang}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaykhaigiang(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Ngày bế giảng"
                  value={ngaybegiang}
                  format="DD/MM/YYYY"
                  onChange={(newValue) => {
                    setNgaybegiang(newValue);
                  }}
                  slotProps={{ textField: { size: "small" } }}
                  views={["day", "month", "year"]}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "35px",
                    },
                  }}
                />
              </LocalizationProvider>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Số lượng học viên"
                variant="outlined"
                size="small"
                type="number"
                value={soluonghocvien}
                onChange={(event) => {
                  setSoluonghocvien(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Số lượng giáo viên lý thuyết"
                variant="outlined"
                size="small"
                type="number"
                value={soluonggiaovienlythuyet}
                onChange={(event) => {
                  setSoluonggiaovienlythuyet(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Số lượng giáo viên thực hành"
                variant="outlined"
                size="small"
                type="number"
                value={soluonggiaovienthuchanh}
                onChange={(event) => {
                  setSoluonggiaovienthuchanh(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Số lượng xe"
                variant="outlined"
                type="number"
                size="small"
                value={soluongxe}
                onChange={(event) => {
                  setSoluongxe(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <FormControl style={{ width: "100%", marginTop: 12 }}>
              <TextField
                label="Ghi chú"
                variant="outlined"
                size="small"
                value={ghichu}
                onChange={(event) => {
                  setGhichu(event.target.value);
                }}
                InputProps={{
                  style: {
                    height: "35px",
                  },
                }}
              />
            </FormControl>
          </GridItem>
        </GridContainer>
      </CardBody>
      {/** fix css */}
      <CardFooter style={{ marginBottom: "30px" }}>
        <Button
          color="primary"
          variant="contained"
          style={{ height: 27 }}
          onClick={capnhat}
        >
          Cập nhật
        </Button>
      </CardFooter>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message={messageValidate}
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
});

Capnhatkhoahoc.propTypes = {
  cosodaotao_id: PropTypes.object,
  khoahocid: PropTypes.number,
};
export default Capnhatkhoahoc;
